export function withdrawStatus(status){
    switch(status){
        case 1: default: return { colorPalette: null, icon: 'done' }; break;
        case 2: return { colorPalette: 'yellow', icon: 'waiting' }; break;
        case 3: return { colorPalette: 'teal', icon: 'check' }; break;
        case 4: return { colorPalette: 'red', icon: 'canceled' }; break;
        case 5: return { colorPalette: 'red', icon: 'canceled' }; break;
    }
}

export function bonusOperation(operation = 1){
    switch(operation){
        case 1: return { colorPalette: 'green', icon: 'add' }; break;
        case 2: return { colorPalette: 'red', icon: 'remove' }; break;
        default: return { colorPalette: null, icon: 'undefined' }; break;
    }
}

export function activeMonth(status = 1){
    switch(status){
        default: return { colorPalette: 'green', icon: 'add', description: 'Está participando dos benefícios da Bonífica' }; break;
        case 1: return { colorPalette: 'green', icon: 'done', description: 'Está participando dos benefícios da Bonífica' }; break;
        case 2: return { colorPalette: 'red', icon: 'alert', description: 'Realize a sua ativação o quanto antes para não perder os benefícios.' }; break;
        case 3: return { colorPalette: 'orange', icon: 'alert', description: 'Realize a sua ativação o quanto antes para não perder os benefícios.' }; break;
    }
}

export function orderStatus(status = 1){
    switch(status){
        case 1: return { colorPalette: 'teal', icon: 'active', label: 'Rascunho' }; break;
        case 2: return { colorPalette: 'gray', icon: 'check', label: 'Concluído' }; break;
        case 5: return { colorPalette: 'red', icon: 'cancel', label: 'Cancelado' }; break;
        case 3: case 4: case 6: case 7: case 8: return { colorPalette: 'green', icon: 'check', label: 'Aprovado' }; break;
        case 9: return { colorPalette: 'blue', icon: 'transit', label: 'A caminho' }; break;
        case 11: return { colorPalette: 'blue', icon: 'analyzing', label: 'Aguardando retirada' }; break;
        case 12: return { colorPalette: 'orange', icon: 'analyzing', label: 'Em Análise' }; break;
        default: return { colorPalette: null, icon: 'undefined', label: 'N/D' }; break;
    }
}

export function orderHistory(status = 1){
    switch(status){
        case 1: return { colorPalette: 'gray', icon: 'check', label: 'Sacola iniciada' }; break;
        case 2: return { colorPalette: 'gray', icon: 'check', label: 'Pedido recebido' }; break;
        case 3: return { colorPalette: 'gray', icon: 'check', label: 'Pedido aprovado' }; break;
        case 4: return { colorPalette: 'gray', icon: 'check', label: 'Pagamento aprovado' }; break;
        case 5: return { colorPalette: 'gray', icon: 'check', label: 'Em montagem' }; break;
        case 6: return { colorPalette: 'gray', icon: 'check', label: 'Em cotação' }; break;
        case 7: return { colorPalette: 'gray', icon: 'check', label: 'Aguardando transportadora' }; break;
        case 8: return { colorPalette: 'gray', icon: 'check', label: 'Em trânsito' }; break;
        case 9: return { colorPalette: 'gray', icon: 'check', label: 'Aguardando retirada' }; break;
        case 10: return { colorPalette: 'gray', icon: 'check', label: 'Em análise' }; break;
        case 11: return { colorPalette: 'gray', icon: 'check', label: 'Cancelado' }; break;
        case 14: return { colorPalette: 'gray', icon: 'check', label: 'Concluído' }; break;
        default: return { colorPalette: null, icon: 'undefined', label: 'N/D' }; break;
    }
}

export function percentage_vme(percentage = 0){
    if(percentage >= 90) return { colorPalette: 'red', icon: 'active' }
    if(percentage >= 65) return { colorPalette: 'orange', icon: 'active' }
    if(percentage < 65) return { colorPalette: 'green', icon: 'active' }
    return { colorPalette: 'green', icon: 'active' }
}

export function percentage(percentage = 0){
    if(percentage >= 90) return { colorPalette: 'red', icon: 'active' }
    if(percentage >= 65) return { colorPalette: 'orange', icon: 'active' }
    if(percentage < 65) return { colorPalette: 'green', icon: 'active' }
    return { colorPalette: 'green', icon: 'active' }
}

export function pin(pin = 1){
    switch(pin){
        default: case 1: return { colorPalette: null, icon: 'add', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/00CONSULTOR.png' }; break;
        case 2: return { colorPalette: 'gray', icon: 'remove', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/01EMPREENDEDOR.png' }; break;
        case 3: return { colorPalette: 'cyan', icon: 'remove', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/02SENIOR.png' }; break;
        case 4: return { colorPalette: 'teal', icon: 'remove', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/03EXPERT.png' }; break;
        case 5: return { colorPalette: 'orange', icon: 'undefined', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/04ENTERPRISE.png' }; break;
        case 6: return { colorPalette: 'blue', icon: 'undefined', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/05DIAMOND.png' }; break;
        case 7: return { colorPalette: 'purple', icon: 'undefined', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/06DIAMOND%20EXPERT.png' }; break;
        case 8: return { colorPalette: 'blue', icon: 'undefined', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/07DIAMOND%20GLOBAL.png' }; break;
        case 9: return { colorPalette: 'yellow', icon: 'undefined', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/08EMPRESARIAL%20DIAMOND.png' }; break;
        case 10: return { colorPalette: 'green', icon: 'undefined', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/09IMPERIAL%20BONIFIC.png' }; break;
        case 11: return { colorPalette: null, icon: 'undefined', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/10MAJESTIC%20BONIFIC.png' }; break;
        case 12: return { colorPalette: null, icon: 'undefined', image_url: 'https://generic.nyc3.cdn.digitaloceanspaces.com/static/pins/11PRESIDENCIAL.png' }; break;
    }
}

export function transactionMethod(method){
    switch(method){
        default: return { colorPalette: 'orange', icon: 'bonus' }; break;
        case 1: return { colorPalette: 'orange', icon: 'bonus' }; break;
        case 2: return { colorPalette: 'orange', icon: 'home' }; break;
        case 4: return { colorPalette: 'orange', icon: 'bank' }; break;
        case 5: return { colorPalette: 'blue', icon: 'mercadopago' }; break;
        case 6: return { colorPalette: 'orange', icon: 'cash' }; break;
        case 7: return { colorPalette: 'orange', icon: 'third' }; break;
        case 8: return { colorPalette: 'orange', icon: 'voucher' }; break;
        case 9: return { colorPalette: 'orange', icon: 'cielo' }; break;
    }
}

export function transactionStatus(status){
    switch(status){
        default: case 1: return { colorPalette: null, icon: null }; break;
        case 2: return { colorPalette: 'green', icon: 'check' }; break;
        case 3: return { colorPalette: 'orange', icon: 'waiting' }; break;
        case 4: return { colorPalette: 'blue', icon: 'check' }; break;
        case 5: return { colorPalette: 'red', icon: 'cancel' }; break;
        case 6: return { colorPalette: 'red', icon: 'refunded' }; break;
    }
}

export function cieloStatus(status){
    switch(status){
        default: case 1: return { colorPalette: 'orange', icon: 'waiting' }; break;
        case 2: return { colorPalette: 'green', icon: 'check' }; break;
        case 3: return { colorPalette: 'red', icon: 'waiting' }; break;
        case 4: return { colorPalette: 'orange', icon: 'waiting' }; break;
        case 5: return { colorPalette: 'red', icon: 'cancel' }; break;
        case 6: return { colorPalette: 'red', icon: 'refunded' }; break;
        case 7: return { colorPalette: 'green', icon: 'check' }; break;
    }
}

export function cieloLabel(label){
    switch(label){
        default: case 1: return { label: 'Pendente' }; break;
        case 2: return { label: 'Pago' }; break;
        case 3: return { label: 'Negado' }; break;
        case 4: return { label: 'Expirado' }; break;
        case 5: return { label: 'Cancelado' }; break;
        case 6: return { label: 'Não Finalizado' }; break;
        case 7: return { label: 'Autorizado' }; break;
    }
}